export default "__VITE_ASSET__BLy8GqHu__"